import { FIELD_TYPES, numericFieldTypes } from 'utility/constants';
import { truePredicate, falsePredicate } from 'utility/fieldHelpers';

export const cfvChangeTypeOptionsConst = {
  SPECIFIC_VALUE: 'specific_value',
  RELATED_OBJECT_FIELD: 'related_object_field',
  THIS_RECORD_FIELD: 'this_record_field',
  AUTOMATION_VARIABLE: 'variable',
};

export const fieldTypesMeta = {
  [FIELD_TYPES.Decimal.type]: {
    type: FIELD_TYPES.Decimal.type,
    showFieldResolution: true,
    fieldRequiresWizard: false,
    specifiedIsOption: false,
  },
  [FIELD_TYPES.Integer.type]: {
    type: FIELD_TYPES.Integer.type,
    showFieldResolution: true,
    fieldRequiresWizard: false,
    specifiedIsOption: false,
  },
  [FIELD_TYPES.Number.type]: {
    type: FIELD_TYPES.Number.type,
    showFieldResolution: true,
    fieldRequiresWizard: false,
    specifiedIsOption: false,
  },
  [FIELD_TYPES.Price.type]: {
    type: FIELD_TYPES.Price.type,
    showFieldResolution: true,
    fieldRequiresWizard: false,
    specifiedIsOption: false,
  },
  [FIELD_TYPES.Money.type]: {
    type: FIELD_TYPES.Money.type,
    showFieldResolution: true,
    fieldRequiresWizard: false,
    specifiedIsOption: false,
  },
  // text
  [FIELD_TYPES.Email.type]: {
    type: FIELD_TYPES.Email.type,
    showFieldResolution: true,
    fieldRequiresWizard: false,
    specifiedIsOption: false,
  },
  [FIELD_TYPES.LongText.type]: {
    type: FIELD_TYPES.LongText.type,
    showFieldResolution: true,
    fieldRequiresWizard: false,
    specifiedIsOption: false,
  },
  [FIELD_TYPES.Text.type]: {
    type: FIELD_TYPES.Text.type,
    showFieldResolution: true,
    fieldRequiresWizard: false,
    specifiedIsOption: false,
  },
  // 5628
  [FIELD_TYPES.Checkbox.type]: {
    type: FIELD_TYPES.Checkbox.type,
    showFieldResolution: true,
    fieldRequiresWizard: false,
    specifiedIsOption: false,
  },
  [FIELD_TYPES.Date.type]: {
    type: FIELD_TYPES.Date.type,
    showFieldResolution: true,
    fieldRequiresWizard: false,
    specifiedIsOption: false,
  },
  [FIELD_TYPES.DateTime.type]: {
    type: FIELD_TYPES.DateTime.type,
    showFieldResolution: true,
    fieldRequiresWizard: false,
    specifiedIsOption: false,
  },
  // 5629
  [FIELD_TYPES.Dropdown.type]: {
    type: FIELD_TYPES.Dropdown.type,
    showFieldResolution: false,
    fieldRequiresWizard: true,
    specifiedIsOption: true,
  },
  [FIELD_TYPES.Radio.type]: {
    type: FIELD_TYPES.Radio.type,
    showFieldResolution: false,
    fieldRequiresWizard: true,
    specifiedIsOption: true,
  },
  [FIELD_TYPES.Rating.type]: {
    type: FIELD_TYPES.Rating.type,
    showFieldResolution: false,
    fieldRequiresWizard: true,
    specifiedIsOption: true,
  },
  [FIELD_TYPES.Status.type]: {
    type: FIELD_TYPES.Status.type,
    showFieldResolution: false,
    fieldRequiresWizard: true,
    specifiedIsOption: true,
  },
  [FIELD_TYPES.TeamSelector.type]: {
    type: FIELD_TYPES.TeamSelector.type,
    showFieldResolution: false,
    fieldRequiresWizard: false,
    specifiedIsOption: true,
  },
  [FIELD_TYPES.YesNoMaybe.type]: {
    type: FIELD_TYPES.YesNoMaybe.type,
    showFieldResolution: false,
    fieldRequiresWizard: true,
    specifiedIsOption: true,
  },
  [FIELD_TYPES.Checkboxes.type]: {
    type: FIELD_TYPES.Checkboxes.type,
    showFieldResolution: false,
    fieldRequiresWizard: true,
    specifiedIsOption: false,
  },
  [FIELD_TYPES.DynamicTags.type]: {
    type: FIELD_TYPES.DynamicTags.type,
    showFieldResolution: false,
    fieldRequiresWizard: false,
    specifiedIsOption: false,
  },
};

export const showFieldResolution = (type) =>
  fieldTypesMeta[type].showFieldResolution || false;

export const fieldRequiresWizard = (type) =>
  type ? fieldTypesMeta[type]?.fieldRequiresWizard || false : false;

export const specifiedIsOption = (type) =>
  type ? fieldTypesMeta[type].specifiedIsOption || false : false;

export const isValueTypeRelated = (ftm) =>
  ftm?.value === cfvChangeTypeOptionsConst.RELATED_OBJECT_FIELD;

export const isValueTypeThisRecord = (ftm) =>
  ftm?.value === cfvChangeTypeOptionsConst.THIS_RECORD_FIELD;

export const numberFieldTypes = [
  FIELD_TYPES.Integer.type,
  FIELD_TYPES.Decimal.type,
  FIELD_TYPES.Number.type,
];

export const hasOptionsWizard = (
  fieldToModify,
  changeType,
  relatedObjectField
) => {
  return (
    fieldRequiresWizard(fieldToModify?.fieldType) &&
    !(changeType.value === cfvChangeTypeOptionsConst.SPECIFIC_VALUE) &&
    relatedObjectField
  );
};

export const fieldsTypesToAddClear = [
  FIELD_TYPES.DateTime.type,
  FIELD_TYPES.Dropdown.type,
  FIELD_TYPES.Relationship.type,
  FIELD_TYPES.Timezone.type,
  FIELD_TYPES.Status.type,
  FIELD_TYPES.TeamSelector.type,
  FIELD_TYPES.Email.type,
];
export const changeTypeOptionsFactory = (t, predicate = truePredicate) =>
  [
    {
      value: cfvChangeTypeOptionsConst.SPECIFIC_VALUE,
      label: t('Specific Value'),
      filterable: false,
      isVariable: false,
    },
    {
      value: cfvChangeTypeOptionsConst.RELATED_OBJECT_FIELD,
      label: t('Field Value on a Primary Related Object (Variable)'),
      filterable: true,
      isVariable: false,
    },
    {
      value: cfvChangeTypeOptionsConst.THIS_RECORD_FIELD,
      label: t('Field Value on This Record'),
      filterable: false,
      isVariable: false,
    },
    {
      value: cfvChangeTypeOptionsConst.AUTOMATION_VARIABLE,
      label: t('Automation Variable'),
      filterable: false,
      isVariable: false,
    },
  ].filter(predicate);

export const validFieldTypes = [
  ...numericFieldTypes,
  // text
  FIELD_TYPES.Email.type,
  FIELD_TYPES.LongText.type,
  FIELD_TYPES.Text.type,
  // option/select
  FIELD_TYPES.Checkbox.type,
  FIELD_TYPES.Checkboxes.type,
  FIELD_TYPES.Dropdown.type,
  FIELD_TYPES.DynamicTags.type,
  FIELD_TYPES.Radio.type,
  FIELD_TYPES.Status.type,
  FIELD_TYPES.TeamSelector.type,
  FIELD_TYPES.YesNo.type,
  FIELD_TYPES.YesNoMaybe.type,
  // date / phone
  FIELD_TYPES.Date.type,
  FIELD_TYPES.DateTime.type,
  FIELD_TYPES.PhoneNumber.type,
  // 5591
  FIELD_TYPES.Files.type,
  FIELD_TYPES.Relationship.type,
  FIELD_TYPES.Rating.type,
  // 7436
  FIELD_TYPES.Timezone.type,
];

export const fieldTypeFilter = ({ fieldType }) => {
  return validFieldTypes.includes(fieldType);
};
// add fields to this list that you ca use Field Value on a Primary Related Object

export const validValueFieldTypes = [
  ...numericFieldTypes,
  // text
  FIELD_TYPES.Email.type,
  FIELD_TYPES.LongText.type,
  FIELD_TYPES.Text.type,
  // 5291
  FIELD_TYPES.Checkbox.type,
  FIELD_TYPES.Date.type,
  FIELD_TYPES.DateTime.type,
  FIELD_TYPES.DynamicTags.type,
  FIELD_TYPES.Files.type,
  FIELD_TYPES.Relationship.type,
  // 5589
  FIELD_TYPES.Dropdown.type,
  FIELD_TYPES.Checkboxes.type,
  FIELD_TYPES.Radio.type,
  FIELD_TYPES.Status.type,
  // 6752
  FIELD_TYPES.YesNo.type,
  FIELD_TYPES.YesNoMaybe.type,
  FIELD_TYPES.TeamSelector.type,
  FIELD_TYPES.Rating.type,
  // 7436
  FIELD_TYPES.Timezone.type,
];
// controls which options are shown in the Choose Field Resolution selector
export const relatedFieldsWithResolution = {
  [FIELD_TYPES.DynamicTags.type]: {
    show: true,
    onlyAddPredicate: truePredicate,
  },
  [FIELD_TYPES.Files.type]: { show: true, onlyAddPredicate: truePredicate },
  [FIELD_TYPES.Relationship.type]: {
    show: true,
    onlyAddPredicate: (field) => {
      const { relation } = field;
      return (
        relation &&
        relation.relationType !== 'primary' &&
        !['one_to_one', 'many_to_one'].includes(relation.cardinalty)
      );
    },
  },
  [FIELD_TYPES.Dropdown.type]: { show: true, onlyAddPredicate: falsePredicate },
  [FIELD_TYPES.Checkboxes.type]: {
    show: true,
    onlyAddPredicate: truePredicate,
  },
  [FIELD_TYPES.Radio.type]: { show: true, onlyAddPredicate: falsePredicate },
  [FIELD_TYPES.Status.type]: { show: true, onlyAddPredicate: falsePredicate },
  [FIELD_TYPES.YesNo.type]: { show: true, onlyAddPredicate: falsePredicate },
  [FIELD_TYPES.YesNoMaybe.type]: {
    show: true,
    onlyAddPredicate: falsePredicate,
  },
  [FIELD_TYPES.TeamSelector.type]: {
    show: true,
    onlyAddPredicate: falsePredicate,
  },
  [FIELD_TYPES.Rating.type]: { show: true, onlyAddPredicate: falsePredicate },
  [FIELD_TYPES.Timezone.type]: { show: true, onlyAddPredicate: falsePredicate },
};
export const valueTypePedicate =
  (fieldType) =>
  ({ filterable }) =>
    !filterable || validValueFieldTypes.includes(fieldType);
export const addOnlyPedicate =
  (fieldToModify) =>
  ({ filterable }) => {
    const { fieldType } = fieldToModify || {};

    /* temporary hides field resolutions for dynamic tags untill 
    https://kizen.atlassian.net/browse/KZN-13490 is ready. Should be 
    unhidden in https://kizen.atlassian.net/browse/KZN-13495*/
    if (fieldType === FIELD_TYPES.DynamicTags.type) {
      return (
        filterable &&
        relatedFieldsWithResolution?.[fieldType]?.onlyAddPredicate(
          fieldToModify
        )
      );
    }
    return (
      !filterable ||
      relatedFieldsWithResolution?.[fieldType]?.onlyAddPredicate(fieldToModify)
    );
  };
